export default "__VITE_ASSET__abac0cac__"